import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import api from '@/api';
import { NotFoundScreen } from '@/common/ErrorScreen';
import { TitleWithQuestion } from '@/common/TitleWithQuestion';
import StudyActivitiesTable from '@/tables/StudyActivitiesTable';
import { useStudyActivitiesTabAccess } from '~/hooks/useStudyActivitiesTabAccess';
import { GroupHeaderWrapper } from '~/styles/layoutElements';

function StudyActivitiesScreen() {
  const { t } = useTranslation();
  const { groupName } = Route.useParams();
  // One table for every viewer and group type, as legacy renders a single table
  // here.
  const { canView, isResolved } = useStudyActivitiesTabAccess();
  const { data: groupData } = api.getGroupBySlug.useQuery({
    path: { group_slug: groupName },
  });

  // Not a no-op: painting the heading before the group type lands would flash it
  // at a viewer the next line refuses.
  if (!isResolved) return null;
  // Refuse unless both the group's type and the viewer's role allow it. Without
  // this the endpoint's 403 paints an empty table, which reads as "no study
  // activity" rather than a denial.
  if (!canView) return <NotFoundScreen />;

  return (
    <>
      <GroupHeaderWrapper>
        {/* The `students` placement, shared by every table under this tab. */}
        <TitleWithQuestion
          title={t('lessons.study-activities')}
          placement="students"
        />
      </GroupHeaderWrapper>
      <StudyActivitiesTable groupId={groupData?.id ?? 0} />
    </>
  );
}

export const Route = createFileRoute(
  '/_app/_dashboard/groups/$groupName/students/study-activities',
)({
  component: StudyActivitiesScreen,
});
